"use client";

import type { ReactNode } from "react";

/** A toggle in Ejendomme's tab look. While its request runs it shows a spinner and ignores clicks, but it is never
 *  disabled, so focus stays on it; outside an interactive page it is drawn inert. */
export default function ListFilterButton({
  pressed,
  busy = false,
  interactive = true,
  onClick,
  children,
  label,
}: {
  pressed: boolean;
  busy?: boolean;
  interactive?: boolean;
  onClick?: () => void;
  children: ReactNode;
  label?: string;
}) {
  return (
    <button
      type="button"
      className="pf-filter"
      aria-pressed={pressed}
      aria-busy={busy || undefined}
      aria-disabled={interactive ? undefined : true}
      aria-label={label}
      onClick={interactive && !busy ? onClick : undefined}
    >
      {busy && <span className="pf-filter-spinner animate-spin" aria-hidden />}
      {children}
    </button>
  );
}
